module.exports = __webpack_public_path__ + "static/image/font/pc/kkubulim-5.ver2_0_2.png?4bd9646e";